const CheckboxComponent = {
    templateUrl: '/formViewer/component/checkbox/checkbox.tpl.html',
    controller: 'checkboxController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('uiCheckbox', CheckboxComponent);
